import styled from "styled-components";
import { CenterFlexRow } from "styles/layout";

export const TeamsContainer = styled(CenterFlexRow)`
  justify-content: space-evenly;
`;

export const ByeTBD = styled.span`
  font-size: 16pt;
  color: gray;
`;

export const OrgLogoContainer = styled.div`
  margin-top: 5px;
  width: 80px;
  height: 60px;

  @media (max-width: 700px) {
    width: 65px;
    height: 55px;
  }

  @media (max-width: 500px) {
    width: 45px;
    height: 40px;
  }
`;

export const DisplayName = styled.span`
  font-weight: 500;
  font-size: 13pt;
  margin-top: 10px;

  @media (max-width: 600px) {
    font-size: 12pt;
  }

  @media (max-width: 500px) {
    font-size: 10pt;
  }
`;

export const TeamScore = styled.span`
  text-align: center;
  font-weight: 500;
  font-size: 13pt;
  margin-top: 10px;

  @media (max-width: 600px) {
    font-size: 12pt;
  }

  @media (max-width: 500px) {
    margin-top: 5px;
    font-size: 11.5pt;
  }
`;
